import { render, staticRenderFns } from "./PhosphorRequirement.vue?vue&type=template&id=895988e8&lang=html&"
import script from "./PhosphorRequirement.vue?vue&type=script&lang=js&"
export * from "./PhosphorRequirement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports